import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Cache a nivel de módulo para no re-pedir el catálogo en cada página.
let _cache = null;
let _inflight = null;

async function _load() {
  if (_cache) return _cache;
  if (_inflight) return _inflight;
  _inflight = axios
    .get(`${BACKEND_URL}/api/articles`, { withCredentials: true })
    .then((res) => {
      const map = {};
      (res.data || []).forEach((a) => {
        if (a.article_id) map[a.article_id] = a.unit || 'unidad';
      });
      _cache = map;
      _inflight = null;
      return map;
    })
    .catch(() => {
      _inflight = null;
      return {};
    });
  return _inflight;
}

/**
 * Devuelve unitOf(articleId) que resuelve la unidad de medida de un artículo.
 * Soporta ids espejo (`base__d_dest`) tomando la unidad del artículo base.
 * Fallback: "unidad".
 */
export function useArticleUnits() {
  const [map, setMap] = useState(_cache || {});

  useEffect(() => {
    let alive = true;
    _load().then((m) => { if (alive) setMap(m); });
    return () => { alive = false; };
  }, []);

  const unitOf = useCallback(
    (articleId) => {
      if (!articleId) return 'unidad';
      if (map[articleId]) return map[articleId];
      const base = String(articleId).split('__d_')[0];
      return map[base] || 'unidad';
    },
    [map]
  );

  return { unitOf };
}
